import { findWhere, result, values } from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { Breadcrumb } from '@bingads-webui-react/breadcrumb';
import { CampaignType } from '@bingads-webui-campaign-react/shell-ui-common';
import {
  campaignTypes,
  convertToBreadCrumbItems,
} from '../helpers';

export class SummaryBarBreadcrumb extends React.PureComponent {
  render() {
    const {
      campaignType,
      classes,
      i18n,
      maxDisplayedItems,
    } = this.props;

    const items = convertToBreadCrumbItems(this.props);
    const currentCampaignType = findWhere(campaignTypes, { id: campaignType });
    const campaignTypeI18nText = i18n.getString(result(currentCampaignType, 'i18nKey'));

    return (
      <div className={classes.summaryBarBreadcrumb}>
        <Breadcrumb
          items={items}
          maxDisplayedItems={maxDisplayedItems}
          overflowAriaLabel={campaignTypeI18nText}
          tooltipPlacement="bottom"
        />
      </div>
    );
  }
}

SummaryBarBreadcrumb.propTypes = {
  classes: PropTypes.shape({
    summaryBarBreadcrumb: PropTypes.string,
  }),
  campaignType: PropTypes.oneOf(values(CampaignType)).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  maxDisplayedItems: PropTypes.number,
  summaryBarActivityLogger: PropTypes.shape({
    changeScopeActivity: PropTypes.any,
  }),
};

SummaryBarBreadcrumb.defaultProps = {
  classes: {
    summaryBarBreadcrumb: 'summary-bar-breadcrumb',
  },
  maxDisplayedItems: 3,
  summaryBarActivityLogger: null,
};
